import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
//import {Alert} from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Auth from './auth'

class Home extends Component {

    componentDidMount() {
        Auth.logout();
    }
    render() {
        return (
            <Redirect to={{ pathname: "/" }} />
        );
    }
}
export default (Home);


// WEBPACK FOOTER //
// ./src/middleware/cerrarsesion.jsx